// Libraries
import { FC } from "react";
import { Provider, Root, Trigger, Portal, Arrow, Content } from "@radix-ui/react-tooltip";
import classNames from "classnames";

// Types
import { TooltipProps } from "./TooltipV2.types";

export const TooltipV2: FC<TooltipProps> = ({
  children,
  content,
  className,
  delayDuration,
  backgroundColor = "bg-card",
}) => {
  const delayedDuration = typeof delayDuration === "number" ? delayDuration : 100;
  const contentClasses = classNames(
    "data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade text-foreground select-none rounded-lg p-3 select-none font-inter leading-none shadow-[0_10px_25px_-5px_rgba(0,0,0,0.8),0_4px_6px_-2px_rgba(0,0,0,0.6)] will-change-[transform,opacity]",
    className
  );

  return (
    <Provider delayDuration={delayedDuration}>
      <Root>
        <Trigger asChild>{children}</Trigger>
        <Portal>
          {content && (
            <Content className={classNames(contentClasses, backgroundColor, "z-[260]")}>
              {content}
              <Arrow
                className={`w-3 h-3 bottom-[-0.15rem] z-[-1] p-1 transform translate-y-[-6px] rotate-45 color-gray ${backgroundColor}`}
                asChild
              >
                <span />
              </Arrow>
            </Content>
          )}
        </Portal>
      </Root>
    </Provider>
  );
};

export default TooltipV2;
